import { IdVerification, TermSet } from '@zg-rentals/id-verification';
import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { useRouter } from 'next/router';
import { useAuth } from '../AuthProvider';
import { trackUserEvent } from '../analytics';
import { BASE_URL, EXTERNAL_URLS, type ROUTES } from '../constants/urls';

export default function IdVerificationPage() {
  const router = useRouter<typeof ROUTES.ID_VERIFICATION>();
  const { applicationsUrlPath } = router.query;
  const { user: userData } = useAuth();

  function onExit() {
    window.location.href = applicationsUrlPath ? `${BASE_URL}${applicationsUrlPath}` : EXTERNAL_URLS.PROPERTIES;
  }

  return (
    userData && (
      <IdVerification
        id="applications-landlord-web"
        onExit={onExit}
        termSet={TermSet.LandlordScreening}
        zgApi={BASE_URL}
        pidAnswersForReview={{
          firstName: userData?.firstName || '',
          middleName: '',
          lastName: userData?.lastName || '',
          currentAddress: '',
          currentCity: '',
          currentState: '',
          currentZip: '',
          phone: '',
        }}
        trackEvent={(basePayload) => {
          trackUserEvent({
            ...basePayload,
            ...getZrmUserInfo(userData),
          });
        }}
      />
    )
  );
}
